import './PreviewTable.scoped.scss'

export default function PreviewTable({ dashboardId }) {
  const iframeRef = useRef(null)
  const { currentEditor } = useSel(s => s.builder)

  return (
    <div className="dashboard-preview-container">
      {currentEditor === "preview" &&
        <iframe 
          ref={iframeRef}
          src={`/dashboards/${dashboardId}/preview`}
          className="dashboard-iframe"
          title="Dashboard Preview"
        />
      }
    </div>
  )
}
